import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as extract from 'extractFromState';
import * as paths from 'constants/commerceWizardPathOptions';
import * as actions from 'actions/CommerceWizardActions';
import * as listTypes from 'constants/infoPanelTypes';
import { Wrapper, SelectionPath, HouseIcon, SelectionPathSection } from './CWBreadcrumb.styles';

const CWBreadcrumb = (props) => {
  const getPathName = (path) => {
    switch (path) {
      case paths.CROSS_SELL_PRODUCTS:
        return 'Product';
      default:
        return path;
    }
  };

  const isPathLink = (path) => {
    const { commerceWizardPath = [] } = props;
    const pathLength = commerceWizardPath.length;
    const idxOfPathSection = commerceWizardPath.indexOf(path);

    if (idxOfPathSection < 0) {
      // selected products are not listed in path
      return false;
    }

    const atEndOfPath = pathLength === idxOfPathSection + 1;
    if (atEndOfPath && !props.selectedRecommendation) {
      return false;
    }

    return true;
  };

  const renderCrumb = (path) => {
    const isLink = isPathLink(path);

    return (
      <SelectionPathSection key={path} onClick={() => handleCrumbClick(path, isLink)} isLink={isLink}>
        <span>{getPathName(path)}&nbsp;</span>
        {isLink && <img src="/images/breadcrumb-arrow.svg" alt="arrow" />}
      </SelectionPathSection>
    );
  };

  const getPath = () => {
    const totalPath = props.commerceWizardPath.map((path) => renderCrumb(path));
    if (props.selectedRecommendation) {
      totalPath.push(renderCrumb('Suggested Macro'));
    }

    if (props.selectedPreviousRecommendation) {
      totalPath.push(renderCrumb('Previous Recommendation'));
    }

    return totalPath;
  };

  const handleCrumbClick = (path, isLink) => {
    if (isLink) {
      const idx = props.commerceWizardPath.indexOf(path);
      props.setCommerceWizardSelectedProduct(null);
      props.setCommerceWizardPreviousRecommendation(null);
      props.setCommerceWizardPath(props.commerceWizardPath.slice(0, idx + 1));
    }
  };

  const handleHomeClick = () => {
    props.setCommerceWizardSelectedProduct(null);
    props.setCommerceWizardPreviousRecommendation(null);
    props.setCommerceWizardPath([]);
  };

  const showBreadCrumbs = () => {
    return props.listType !== listTypes.COMMERCE_ON_DEMAND;
  };

  return (
    showBreadCrumbs() && (
      <Wrapper>
        <HouseIcon key={'Home'} onClick={() => handleHomeClick()} src="/images/breadcrumb-house.svg" alt="Home" />
        <SelectionPath>{getPath()}</SelectionPath>
      </Wrapper>
    )
  );
};

CWBreadcrumb.propTypes = {
  commerceWizardPath: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  selectedRecommendation: PropTypes.object,
  selectedPreviousRecommendation: PropTypes.func.isRequired,
  listType: PropTypes.string.isRequired,
  setCommerceWizardPath: PropTypes.func.isRequired,
  setCommerceWizardSelectedProduct: PropTypes.func.isRequired,
  setCommerceWizardPreviousRecommendation: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  commerceWizardPath: extract.extractCommerceWizardPath(state),
  selectedRecommendation: extract.extractCommerceWizardSelectedRecommendation(state),
  selectedPreviousRecommendation: extract.extractCommerceWizardSelectedPreviousRecommendation(state),
  listType: extract.extractInfoPanelListTypeFromState(state),
});

const mapDispatchToProps = {
  setCommerceWizardPath: actions.setCommerceWizardPath,
  setCommerceWizardSelectedProduct: actions.setCommerceWizardSelectedProduct,
  setCommerceWizardPreviousRecommendation: actions.setCommerceWizardPreviousRecommendation,
};

export default connect(mapStateToProps, mapDispatchToProps)(CWBreadcrumb);
